import { registerSW } from 'virtual:pwa-register';

/**
 * 서비스워커 갱신 제어.
 *
 * skipWaiting/clientsClaim 을 끈 이유: 세션 도중 서비스워커가 스스로 교체되면
 * 자산 버전이 바뀌거나 페이지가 리로드될 수 있다. 트라이얼 한복판에서 그런 일이
 * 일어나면 그 참가자의 데이터는 버려야 한다.
 *
 * 갱신은 "지금 세션 중이 아님"을 확인한 뒤 applyUpdate() 로 직접 적용한다.
 */

let applyUpdate: ((reload?: boolean) => Promise<void>) | null = null;
let updateReady = false;
const listeners = new Set<(ready: boolean) => void>();

export function setupPWA(): void {
  if (!('serviceWorker' in navigator)) return;
  applyUpdate = registerSW({
    immediate: true,
    onNeedRefresh() {
      updateReady = true;
      for (const l of listeners) l(true);
    },
    onOfflineReady() {
      // 프리캐시 완료 = 네트워크 없이도 세션 실행 가능.
    },
  });
}

export function onUpdateReady(cb: (ready: boolean) => void): () => void {
  listeners.add(cb);
  cb(updateReady);
  return () => listeners.delete(cb);
}

export function isUpdateReady(): boolean { return updateReady; }

/** 세션 중이 아닐 때만 호출할 것. */
export async function applyPendingUpdate(): Promise<void> {
  await applyUpdate?.(true);
}
